import * as z from "zod";

export const ISODateString = z.iso
  .datetime()
  .transform((data) => new Date(data))
  .or(z.date());

export const TimeString = z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/);

export function createPrefixedSchema<
  T extends Record<string, z.ZodTypeAny>,
  P extends string,
>(prefix: P, schema: T) {
  const prefixedShape = Object.fromEntries(
    Object.entries(schema).map(([key, zodType]) => [
      `${prefix}/${key}`,
      zodType,
    ]),
  ) as { [K in keyof T as `${P}/${string & K}`]: T[K] };

  return z.object(prefixedShape);
}
